import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface GraphicFeatureProps {
  items: Article[];
}

export default function GraphicFeature({ items }: GraphicFeatureProps) {
  return (
    <section id="graphic" className="bg-foreground-950 text-background-100">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.28em] uppercase text-accent-400">
              <span className="w-6 h-px bg-accent-500" />
              图解专栏
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              一张图，把内幕讲到能复述
            </h2>
            <p className="mt-3 text-sm md:text-base text-background-300 leading-relaxed">
              事件里最容易被忽略的往往是时间先后与数字关系。把它们画成图之后，你可以自己判断哪一步才是关键。
            </p>
          </div>
          <Link
            to="/feed?cat=tech"
            className="shrink-0 inline-flex items-center gap-1.5 text-sm font-medium text-background-50 hover:text-accent-400 transition-colors whitespace-nowrap"
          >
            查看全部图解
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((article) => {
            const graphic = article.gallery[0];
            return (
              <article key={article.id} className="rounded-lg overflow-hidden bg-secondary-950 border border-secondary-800 flex flex-col">
                <div className="w-full h-44 overflow-hidden">
                  <img src={graphic.src} alt={graphic.alt} className="w-full h-full object-cover object-top" />
                </div>
                <div className="flex-1 flex flex-col p-5">
                  <span className="text-xs font-medium text-accent-400">{article.category}</span>
                  <h3 className="mt-2 font-heading text-base font-bold text-background-50 leading-snug">
                    <Link to={`/article/${article.slug}`} className="hover:text-accent-300 transition-colors line-clamp-2">
                      {article.title}
                    </Link>
                  </h3>
                  <ul className="mt-4 space-y-2.5 flex-1">
                    {article.keyPoints.slice(0, 3).map((point) => (
                      <li key={point} className="flex gap-2 text-xs text-background-300 leading-relaxed">
                        <i className="ri-checkbox-blank-circle-fill text-[6px] mt-1.5 text-secondary-500 shrink-0" />
                        <span className="line-clamp-2">{point}</span>
                      </li>
                    ))}
                  </ul>
                  <p className="mt-4 text-xs text-background-400">{graphic.caption}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}